import { Component, OnInit } from '@angular/core';
import { UserService } from 'src/app/services/user.service';
import { RoleService } from 'src/app/services/role.service';
import { AbilityService } from 'src/app/services/ability.service';
import { PermissionsService } from 'src/app/services/permissions.service';
import { User } from 'src/app/models/user';
import { Role } from 'src/app/models/role';
import { Ability } from 'src/app/models/ability';
import { Permissions } from 'src/app/models/permissions';
import { ToastrManager } from 'ng6-toastr-notifications';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.css']
})
export class AuthComponent implements OnInit {
  users: User[] = [];
  roles: Role[] = [];
  abilities: Ability[] = [];
  user: User;
  role: Role;
  ability: Ability;
  roleAbilities: Ability[] = [];
  roleAbility: Ability;
  loading: boolean;
  userPerm: Permissions;

  constructor(private userServ:UserService, private roleServ:RoleService, private abilityServ:AbilityService, private permServ:PermissionsService, private toastr:ToastrManager) { }

  async ngOnInit() {
    this.loading = true;
    this.users = await this.getUsers();
    this.roles = await this.getRoles();
    this.abilities = await this.getAbilities();
    this.loading = false;
  }

  async getUsers() : Promise<User[]> {
    return await this.userServ.getUsers();
  }

  async getRoles() : Promise<Role[]> {
    return await this.roleServ.getRoles();
  }

  async getAbilities() : Promise<Ability[]> {
    return await this.abilityServ.getAbilities();
  }

  async selectUser(user:User) {
    this.user = user;
    this.userPerm = await this.permServ.loadPermissions(user);
    this.updateView();
  }

  async selectRole(role:Role) {
    this.role = role;
    this.roleAbilities = await this.getAbilitiesFromRole(role);
    this.updateView();
  }

  selectAbility(ability:Ability) {
    this.ability = ability;
  }

  async getAbilitiesFromRole(role:Role) : Promise<Ability[]> {
    return this.permServ.loadRoleAbilities(role);
  }

  selectRoleAbility(ability:Ability) {
    this.roleAbility = ability;
  }

  updateView() {
    if(this.userPerm) {
      //update roles
      for(let j = 0; j < this.roles.length; j++) {
        this.roles[j].active = false;
      }

      for(let i = 0; i < this.userPerm.roles.length; i++) {
        for(let j = 0; j < this.roles.length; j++) {
          if(this.userPerm.roles[i].id == this.roles[j].id) {
            this.roles[j].active = true;
          }
        }
      }

      //update direct abilities
      for(let j = 0; j < this.abilities.length; j++) {
        this.abilities[j].active = false;
      }

      for(let i = 0; i < this.userPerm.abilities.length; i++) {
        for(let j = 0; j < this.abilities.length; j++) {
          if(this.userPerm.abilities[i].id == this.abilities[j].id) {
            this.abilities[j].active = true;
          }
        }
      }

      for(let j = 0; j < this.roleAbilities.length; j++) {
        this.roleAbilities[j].active = false;
      }
        
      for(let i = 0; i < this.userPerm.forbidden.length; i++) {
        for(let j = 0; j < this.roleAbilities.length; j++) {
          if(this.userPerm.forbidden[i].id == this.roleAbilities[j].id) {
            this.roleAbilities[j].active = true;
          }
        }
      }
    }
  }

  async addRoleToUser() {
    if(this.role && this.user) {
      this.loading = true;
      await this.permServ.addRoleToUser(this.role, this.user);
      this.userPerm = await this.permServ.loadPermissions(this.user);
      this.updateView();
      this.loading = false;
    } else {
      this.toastr.infoToastr("No se ha seleccionado ningún usuario y/o rol");
    }
  }

  async removeRoleToUser() {
    if(this.role && this.user) {
      this.loading = true;
      await this.permServ.removeRoleToUser(this.role, this.user);
      this.userPerm = await this.permServ.loadPermissions(this.user);
      this.updateView();
      this.loading = false;
    } else {
      this.toastr.infoToastr("No se ha seleccionado ningún usuario y/o rol");
    }
  }

  async addAbilityToUser() {
    if(this.ability && this.user) {
      this.loading = true;
      await this.permServ.addAbilityToUser(this.ability, this.user);
      this.userPerm = await this.permServ.loadPermissions(this.user);
      this.updateView();
      this.loading = false;
    } else {
      this.toastr.infoToastr("No se ha seleccionado ningún usuario y/o habilidad");
    }
  }

  async removeAbilityToUser() {
    if(this.ability && this.user) {
      this.loading = true;
      await this.permServ.removeAbilityToUser(this.ability, this.user);
      this.userPerm = await this.permServ.loadPermissions(this.user);
      this.updateView();
      this.loading = false;
    } else {
      this.toastr.infoToastr("No se ha seleccionado ningún usuario y/o habilidad");
    }
  }

  async blockAbilityToUser() {
    if(this.roleAbility && this.user) {
      this.loading = true;
      await this.permServ.blockAbilityToUser(this.roleAbility, this.user);
      this.userPerm = await this.permServ.loadPermissions(this.user);
      this.updateView();
      this.loading = false;
    } else {
      this.toastr.infoToastr("No se ha seleccionado ningún usuario y/o habilidad");
    }
  }

  async unblockAbilityToUser() {
    if(this.roleAbility && this.user) {
      this.loading = true;
      await this.permServ.unblockAbilityToUser(this.roleAbility, this.user);
      this.userPerm = await this.permServ.loadPermissions(this.user);
      this.updateView();
      this.loading = false;
    } else {
      this.toastr.infoToastr("No se ha seleccionado ningún usuario y/o habilidad");
    }
  }

}
